import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpMoReportPage } from '@/features/pcmp/pages/PcmpMoReportPage';
import { pcmpMoReportSearchSchema } from '@/features/pcmp/types/pcmpMoReport.types';

export const Route = createFileRoute('/_auth/pcmp/reports/mo-wise/')({
  validateSearch: pcmpMoReportSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP MO Wise Report">
      <Suspense fallback={<PageLoader />}>
        <PcmpMoReportPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
